import { createAction, props } from '@ngrx/store';

import { DeliveryLine } from '../../models/feed.model';

export const loadDeliveryLines = createAction(
  '[Feed] Load delivery lines',
  props<{ dateFrom: string; dateTo: string }>(),
);

export const loadDeliveryLinesSuccess = createAction(
  '[Feed] load delivery lines success',
  props<{ deliveryLines: DeliveryLine[] }>(),
);
